import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { useNavigate } from "react-router-dom";
import smallLogo from "../../../Images/loyalStringLogoSmall.png"
import { FaUserCircle } from "react-icons/fa";
import { Icon } from "@iconify/react";
import { Menu, MenuItem } from "@mui/material";
const ResponsiveDrawer = ({ categories,handleLogout,adminLoggedIn }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const handleCategoryClick = (category) => {
    console.log(category)
    setSelectedCategory(category?.id === selectedCategory?.id ? null : category);
  };
  const navigate = useNavigate();

  // console.log(category)
  const [isOpenUserMenu, setIsOpenUserMenu] = useState(false);

  return (
    <>
    <div style={{display:"flex"}}>
      
      
      <IconButton
        style={{
          fontSize:"40px",
          color: "white",
          // transition: "transform 0.3s ease",
          // transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
         
        }}
        onClick={toggleDrawer}
      >
        {isOpen ? <CloseIcon /> :
        
        <MenuIcon  />
        }
      </IconButton>
      </div>
      <Drawer
        anchor="top"
        open={isOpen}
        onClose={toggleDrawer}
        variant="temporary"
      >
        <div style={{width:"100%",
          padding:"10px 0px 10px 0px",
          display:'flex',alignItems:'center',justifyContent:'space-between',
          borderBottom:"1px solid #ddd"
          }}>
          <div style={{paddingLeft:"10px",display:'flex',justifyContent:'center',alignItems:'center',gap:"10px"}}>

            <FaUserCircle size={36} style={{color:'gray'}}/>
            <strong>{adminLoggedIn?.UserName || ""}</strong>
          </div>
          
          
          {isOpen && <CloseIcon onClick={toggleDrawer}/>}
          </div>
        <div
          className="responsiveDrawerMainOuterBox"
          style={{ width: "300px" }}
        >
          {/* <h2>Menu</h2> */}
          <List
           style={{
            maxHeight: "400px", // Set the maximum height for the list
            overflowY: "auto", // Enable vertical scrolling
            // border: "1px solid #ccc", // Optional: Add a border for better visibility
            padding: "10px 0px", // Optional: Add padding for aesthetics
          }} 
          >
            {categories.map((category) => (
              <div key={category.id}>
                <ListItem
                  style={{ paddingLeft: "10px", fontWeight: "bold" }}
                  button
                  onClick={() => handleCategoryClick(category)}
                >
                  <ListItemText primary={category.name} />
                </ListItem>
                <Collapse
                  in={selectedCategory?.id === category?.id}
                  // timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {category?.items?.map((item) => (
                      <ListItem
                        onClick={() => navigate(item.linkto)}
                        key={item.id}
                        button
                      >
                        <ListItemText
                          style={{ paddingLeft: "30px" }}
                          primary={item.name}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              </div>
            ))}
            <ListItem
                  style={{ paddingLeft: "10px", fontWeight: "bold" }}
                  onClick={handleLogout}
                  
                >
                  Logout
                </ListItem>
          </List>
        </div>
      </Drawer>
    </>
  );
};

export default ResponsiveDrawer;
